import { dropAtivo, dropTipoPerfil, dropTipoPessoa } from 'utils/drops';

const getEntidadesFilterFields = (drops = {}) => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'ativo',
    label: 'Ativo',
    type: 'select',
    options: dropAtivo,
    defaultValue: 'SIM',
  },
  {
    name: 'nome',
    label: 'Nome',
    initial: true,
  },
  {
    name: 'pessoa',
    label: 'Pessoa',
    type: 'select',
    options: dropTipoPessoa,
    multiple: true,
  },
  {
    name: 'documento',
    label: 'Nº do Documento',
  },
  {
    name: 'perfil',
    label: 'Perfil',
    type: 'select',
    options: dropTipoPerfil,
  },
  {
    name: 'logradouro',
    label: 'Endereço',
  },
  {
    name: 'localidade',
    label: 'Cidade',
    type: 'select',
    options: drops?.Cidade,
    multiple: true,
  },
  {
    name: 'sigla',
    label: 'UF',
    type: 'select',
    options: drops?.UF,
    multiple: true,
  },
  {
    name: 'telefone',
    label: 'Telefone',
  },
  {
    name: 'email',
    label: 'E-mail',
  },
  {
    name: 'atividade',
    label: 'Atividade',
    type: 'select',
    options: drops?.AtividadeEntidade,
    multiple: true,
  },
  {
    name: 'fantasia',
    label: 'Fantasia',
  },
  {
    name: 'dtcad.i',
    column: 'dtcad',
    label: 'Data de Cadastro Inicial',
    type: 'date',
  },
  {
    name: 'dtcad.f',
    column: 'dtcad',
    label: 'Data de Cadastro Final',
    type: 'date',
  },
  {
    name: 'vendedor',
    label: 'Vendedor',
    type: 'select',
    options: drops?.EntidadeTipo?.filter(
      (tipo) => tipo?.tipo === 'VENDEDOR' || tipo?.tipo === 'REPRESENTANTE'
    ),
    multiple: true,
  },
  {
    name: 'regiao',
    label: 'Região',
    type: 'select',
    options: drops?.RegiaoEntidade,
    multiple: true,
  },
  {
    name: 'codigo',
    label: 'Código',
  },
];

export default getEntidadesFilterFields;
